import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import IssueApi from '@/fetch/bussiness/issue';
import { IssueStatus } from '@/utils/type';
import { Modal, Checkbox, message, Button } from 'antd';
import { HttpStatusCode } from '@/fetch/core/constant';
import { analyzeLog, isEmpty, showMsg } from '@/utils/util';
import './index.scss';
import CommonTitle from '../CommonTitle';
import Label from '../Label';
import { RootState } from '@/redux/store';
import JiraForm from '../JiraForm';
import { request } from '@/fetch/core';
import {
  addGlobalEventListener,
  removeGlobalEventListener,
  sendGlobalEvent,
} from '@/utils/emit';
const fetchApi = new IssueApi();
interface Props {
  open: boolean;
  setOpen: AnyFunc;
  issueNumber: string;
  issueStatus: IssueStatus;
  vehicleName: string;
  LC_BUTTON_R2?: boolean;
}
const CompleteIssueModal = (props: Props) => {
  const formInstance = useRef<any>(null);
  const [showJira, setShowJira] = useState(false);
  const { open, setOpen, issueNumber, LC_BUTTON_R2, issueStatus } = props;
  const eventInfo = useRef<any>({});
  const keyboardUsed = useRef<boolean>(false);
  const forceCloseRef = useRef(false);
  const [, forceUpdate] = useState(0);
  const { list } = useSelector((state: RootState) => state.issue);

  const keyboardConfirmComplete = () => {
    fetchApi.getIssueEvent({ issueNumber: issueNumber }).then((res) => {
      if (res.code === HttpStatusCode.Success) {
        eventInfo.current = res.data;
        forceUpdate((pre) => pre + 1);
        if (showJira) {
          submitJira(() => {
            confirmComplete({
              acceptNewIssue: true,
              forceClose: forceCloseRef.current,
            });
          });
        } else {
          confirmComplete({
            acceptNewIssue: true,
            forceClose: forceCloseRef.current,
          });
        }
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    });
  };

  useEffect(() => {
    if (open) {
      getCurrentIssueEventInfo();
    }
  }, [open]);

  useEffect(() => {
    if (!props.issueNumber || props.issueStatus !== IssueStatus.PROCESS) {
      return;
    }
    // 第一次按快捷键，出弹窗
    if (LC_BUTTON_R2) {
      if (keyboardUsed.current == false) {
        keyboardUsed.current = true;
        setOpen(true);
        sendGlobalEvent('CLOSE_OTHER_MODAL', 'completeIssueModal');
      } else {
        keyboardUsed.current = false;
        keyboardConfirmComplete();
      }
    }
  }, [LC_BUTTON_R2, props.issueNumber]);

  useEffect(() => {
    const cb = (modalName: string) => {
      if (modalName === 'completeIssueModal') {
        return;
      }
      keyboardUsed.current = false;
      setOpen(false);
    };
    addGlobalEventListener('CLOSE_OTHER_MODAL', cb);
    return () => {
      removeGlobalEventListener('CLOSE_OTHER_MODAL', cb);
    };
  }, []);

  const getCurrentIssueEventInfo = async () => {
    try {
      const res = await fetchApi.getIssueEvent({ issueNumber: issueNumber });
      if (res.code === HttpStatusCode.Success) {
        eventInfo.current = res.data;
        forceUpdate((pre) => pre + 1);
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const confirmComplete = async (params: {
    acceptNewIssue: boolean;
    forceClose: boolean;
  }) => {
    const { acceptNewIssue, forceClose } = params;
    try {
      const res = await fetchApi.completeIssue({
        acceptNewIssue: acceptNewIssue,
        issueNumber: issueNumber,
        forceClose: forceClose,
        eventCount: eventInfo.current?.eventCount,
      });
      if (res.code === HttpStatusCode.Success) {
        showMsg({ msg: res.message, type: 'success' });
      } else {
        showMsg({ msg: res.message, type: 'error' });
      }
      setOpen(false);
    } catch (err) {
      console.error(err);
    }
  };

  const toFormData = (data: any) => {
    if (data === null) return null;
    const formData = new FormData();
    formData.append('description', data.description);
    formData.append('topic', data.topic);
    formData.append('severity', data.severity);
    formData.append('isCrash', data.isCrash);
    formData.append('accidentLevel', data.accidentLevel);
    formData.append('version', data.version);
    formData.append('issueNo', data.issueNo);
    formData.append('jiraSource', data.jiraSource);
    formData.append('vehicleName', props.vehicleName);
    data?.debugTime?.forEach((time: any) => {
      formData.append('debugTime', time);
    });
    data?.attachment?.forEach((curr: any) => {
      formData.append('attachment', curr);
    });
    return formData;
  };
  const submitJira = async (cb: AnyFunc) => {
    try {
      const values = await formInstance?.current?.validateFields();
      const { attachment, ...other } = values;
      const requestBody = {
        ...other,
        attachment: attachment?.fileList?.map((item: any) => {
          return item.originFileObj;
        }),
        issueNo: issueNumber,
        jiraSource: 'ISSUE',
      };
      const body = toFormData(requestBody);
      const submitData: RequestOptions = {
        method: 'POST',
        absoluteURL:
          location.protocol +
          '//' +
          process.env.JDX_APP_FETCH_DATA_DOMAIN +
          '/monitor/web/jira/report',
        contentType: 'formData',
        body: body,
      };
      request(submitData).then((resp) => {
        if (resp.code == HttpStatusCode.Success) {
          // message.success('提报成功');
        } else {
          message.error(resp.message);
        }
      });
      cb();
    } catch (e) {}
  };
  const getCompleteContent = () => {
    // 存在非人工告警事件时展示：
    if (eventInfo.current && !isEmpty(eventInfo.current?.eventList)) {
      const opsEvent = eventInfo.current?.eventList?.find(
        (item: any) => item.eventType != 'MANUAL_REPORT'
      );
      if (opsEvent) {
        forceCloseRef.current = true;
        return (
          <div className="message">
            当前车辆事件仍有报警事件：
            {eventInfo.current?.eventList?.map((event: any) => {
              return <Label text={event.eventName} key={event.eventName} />;
            })}
            请确认是否结单，结单后，本次的报警事件将不再生成工单，工单状态为“强制关闭”
          </div>
        );
      } else {
        // 所有事件都是人工告警事件时展示：
        forceCloseRef.current = false;
        return (
          <div className="message">
            当前事件均已消失，结单后，工单状态为【已关闭】
          </div>
        );
      }
    } else {
      forceCloseRef.current = false;
      // 没有事件展示
      return (
        <div className="message">
          当前事件均已消失，结单后，工单状态为【已关闭】
        </div>
      );
    }
  };

  return (
    <>
      <Modal
        destroyOnClose
        centered
        title="结单"
        open={open}
        onCancel={() => {
          setOpen(false);
        }}
        footer={
          <>
            <div className="footer" style={{ justifyContent: 'flex-end' }}>
              <div className="operate">
                <Button
                  onClick={() => {
                    setOpen(false);
                    keyboardUsed.current = false;
                  }}
                  style={{
                    marginRight: '12px',
                  }}
                >
                  取消
                </Button>
                <Button
                  type={'primary'}
                  onClick={() => {
                    if (showJira) {
                      submitJira(() => {
                        confirmComplete({
                          acceptNewIssue: true,
                          forceClose: forceCloseRef.current,
                        });
                      });
                    } else {
                      confirmComplete({
                        acceptNewIssue: true,
                        forceClose: forceCloseRef.current,
                      });
                    }
                  }}
                >
                  确认结单
                </Button>
                {list?.find(
                  (item: any) => item.issueStatus === IssueStatus.ON_HOLD
                ) && (
                  <Button
                    style={{
                      marginLeft: '12px',
                    }}
                    type={'primary'}
                    onClick={() => {
                      if (showJira) {
                        submitJira(() => {
                          confirmComplete({
                            acceptNewIssue: false,
                            forceClose: forceCloseRef.current,
                          });
                        });
                      } else {
                        confirmComplete({
                          acceptNewIssue: false,
                          forceClose: forceCloseRef.current,
                        });
                      }
                    }}
                  >
                    确定结单并受理挂起工单
                  </Button>
                )}
              </div>
            </div>
          </>
        }
        maskClosable={false}
        width={showJira ? 1538 : 800}
      >
        <div
          className="content-container"
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          {getCompleteContent()}
          <CommonTitle title="关联操作" />
          <Checkbox
            style={{
              marginTop: '16px',
              width: '140px',
            }}
            checked={showJira}
            title="提报缺陷"
            onChange={() => {
              setShowJira(!showJira);
              analyzeLog('complete_and_report_jira', '');
            }}
          >
            提报缺陷
          </Checkbox>
          {showJira && (
            <JiraForm
              open={showJira}
              issueNumber={issueNumber}
              setOpen={setShowJira}
              getFormInstance={(formRef) => {
                formInstance.current = formRef;
              }}
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default CompleteIssueModal;
